import {moment, Base64} from 'helpers';
import {format} from './convert';
import {Note} from 'types';

interface ServerNote {
  audioDuration: string;
  date: string;
  duration: string;
  goalId: string;
  isChecked: number;
  isMorning: string;
  listId: string;
  noteId: string;
  noteTypeId: string;
  tagIds: string;
  tags: string;
  taskId: string;
  time: string;
  title: string;
  type: string;
  userId: string;
  value: string;
}

export const note = (note: ServerNote): Note => ({
  category: note.type,
  categoryId: note.noteTypeId === '0' ? undefined : note.noteTypeId,
  date: moment(note.date, format).unix(),
  id: note.noteId,
  morning: note.isMorning === 'true',
  tagIds: note.tagIds,
  text: Base64.decode(note.value),
  time: note.time,
  title: note.title
});
